@if (isCopyTag) {
  @if (isButton || isCopyTag) {
    <button sdCopyToClipBoard
      type="button"
      (click)="onTagClick()"
      [attr.aria-label]="(tagData?.ariaLabel) ? tagData?.ariaLabel : ''"
      (copied)="tagIsCopied($event)"
      [copyClipboard]="tagData?.text"
      class="c--tag is-button {{
        tagData?.theme ? 'is-theme-' + tagData?.theme : 'is-theme-' + themesEnum.dark
      }} {{
        tagData?.iconPos ? 'is-' + tagData?.iconPos : isCopyTag ? 'is-left' : 'is-' + positionEnum.right
      }} {{
        isCopied ? 'is-copied' : ''
      }}"
    >
      @if (isCopied) {
        <sd-icon name="icon-check" [brand]="brand" [size]="iconSize.small" />
      } @else {
        <sd-icon name="icon-copy" [brand]="brand" [size]="iconSize.small" />
      }
      <span class="is-visually-hidden">
        {{'CmsComponent.PromoBanner.copy' | translate}}
      </span>
      {{tagData?.text}}
      <ng-content />
    </button>
  }
}

@if (!isCopyTag) {
  @if (isButton) {
    <button
      type="button"
      (click)="onTagClick()"
      [attr.aria-label]="(tagData?.ariaLabel) ? tagData?.ariaLabel : ''"
      class="c--tag is-button {{
        tagData?.theme ? 'is-theme-' + tagData?.theme : 'is-theme-' + themesEnum.dark
      }} {{
        tagData?.iconPos ? 'is-' + tagData?.iconPos : isCopyTag ? 'is-left' : 'is-' + positionEnum.right
      }}"
    >
      @if (tagData?.iconPos === positionEnum.left) {
        <sd-icon [name]="tagData?.icon" [brand]="brand" [size]="iconSize.small" />
      }
      @if (isCopyTag) {
        <span class="is-visually-hidden">
          {{'CmsComponent.PromoBanner.copy' | translate}}
        </span>
      }
      {{tagData?.text}}
      <ng-content />
      @if (tagData?.iconPos === positionEnum.right) {
        <sd-icon [name]="tagData?.icon" [brand]="brand" [size]="iconSize.small" />
      }
    </button>
  }
}

@if (!isButton && !isCopyTag) {
  <p
    class="c--tag {{
      tagData?.theme ? 'is-theme-' + tagData?.theme : ''
    }} {{
      tagData?.icon || tagData?.media ? tagData?.iconPos ? 'is-' + tagData?.iconPos : 'is-' + positionEnum.right : ''
    }}"
  >
    @if (tagData?.iconPos === positionEnum.left && tagData?.icon) {
      <sd-icon [name]="tagData?.icon" [brand]="brand" [size]="iconSize.small" />
    }
    @if (tagData?.iconPos === positionEnum.left && tagData?.media && !tagData?.icon) {
      <sd-banner [media]="tagData?.media" [isFit]="true" />
    }
    {{tagData?.text}}
    @if (tagData?.iconPos === positionEnum.right && tagData?.icon) {
      <sd-icon [name]="tagData?.icon" [brand]="brand" [size]="iconSize.small" />
    }
    @if (tagData?.iconPos === positionEnum.right && tagData?.media && !tagData?.icon) {
      <sd-banner [media]="tagData?.media" [isFit]="true" />
    }
  </p>
}
